import { render } from "./LotteryGame.vue?vue&type=template&id=7d252ca9&scoped=true"
import script from "./LotteryGame.vue?vue&type=script&lang=js"
export * from "./LotteryGame.vue?vue&type=script&lang=js"

import "./LotteryGame.vue?vue&type=style&index=0&id=7d252ca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d252ca9"]])

export default __exports__